import router from '@/router'
import AuthRoutes from './route-types.js'

/**
 * Navigate to the login page - the CSR one for support users. Centralised so sign-out and every
 * "back to login" link agree.
 *
 * Always a full navigation: App.vue runs its bootstrap once on router.onReady, so a router.push
 * here would render against stale Vuex state.
 *
 * Async so callers can keep awaiting it.
 *
 * @param {{ isSupportUser?: boolean, returnUrl?: string }} [options]
 */
export async function goToLogin(options) {
  const isSupportUser = !!(options && options.isSupportUser)
  const returnUrl = options && options.returnUrl

  const name = isSupportUser ? AuthRoutes.SignInCsrView.name : AuthRoutes.SignInView.name
  const resolved = router.resolve({
    name,
    query: returnUrl ? { returnUrl } : undefined
  })
  window.location.assign(resolved.href)
}

export default { goToLogin }
